import styled, { css } from 'styled-components';
import { ListVariant } from '../../../../_shared/types/trade';
import Badge from '../../../../_shared/components/Badge';
import Box from '../../../../_shared/components/Box';

const titleColorVariant = {
  [ListVariant.LIST]: css`
    background: ${({ theme }) => theme.COLORS.TRANSPARENT};
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  `,
  [ListVariant.GRID]: css`
    background: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    color: ${({ theme }) => theme.COLORS.BASE};
  `
};

export const StyledTitle = styled(Box)`
  max-width: inherit;
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  display: flex;
  justify-content: space-between;

  ${props => titleColorVariant[props.variant]};
`;

export const StyledMakeModelYear = styled(Box)`
  flex: 1 1 auto;
  min-width: 0;
  ${props =>
    props.variant === ListVariant.GRID
      ? css`
          margin-top: -22px;
        `
      : css`
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: 24px;
          line-height: 24px;
        `};
`;

export const StyledTitleInfo = styled(Box)`
  flex: 0 0 auto;
`;

export const StyledBadge = styled(Badge)`
  height: 24px;
  padding: 0 5px;
  width: max-content;

  ${props =>
    props.variant === ListVariant.GRID
      ? css`
          margin-right: 6px;
        `
      : css`
          margin-right: 12px;
          color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
          border: 2px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
          font-size: 18px;
          display: flex;
          align-items: center;
        `};
`;

export const StyledMake = styled.div`
  display: block;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  white-space: nowrap;
  ${props =>
    props.variant === ListVariant.GRID
      ? css`
          margin-top: 5px;
          font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
        `
      : css`
          margin-right: 6px;
          font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
        `};
`;

export const StyledModel = styled.div`
  display: inline-block;
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  margin-right: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
`;

export const StyledTradeHeading = styled(Box)`
  align-items: center;
  white-space: nowrap;
`;

export const StyledLaunchingToActive = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: 14px;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;

export const StyledCurrentBidWrapper = styled.div`
  margin-left: 12px;
`;

export const StyledNoBids = styled.div`
  font-size: 24px;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  white-space: nowrap;
`;
